<template>

    <div>
        <div style="display: inline-block; width: 100px;">
            <a-col :span="12">
                <a-button type="danger"
                          @click="scanningSearchStepActionDelete">
                    <a-icon type="close-circle"/>
                </a-button>
            </a-col>
            <a-col :span="12">
                <a-button  disabled class="ml4">
                    {{scanningActionSettingsItem.seq}}.{{rowIndex}}
                </a-button>
            </a-col>
            <!--                                                                            </a-row>-->
        </div>
        <div style="display: inline-block; width: calc(100% - 100px);" >
            <!--                                                                                <a-row>-->
            <!--action-->
            <div class="ml10">
                <a-col :span="6">
                    <div class="ml4">
                        <label class="foldText">{{ $t('handheldConfiguration.action') }}</label>
                        <a-select show-search
                                  optionFilterProp="label"
                                  v-model="scanningAction"
                                  @change="actionChange">
                            <a-select-option :label="item.action" :value="item.action" :key="item.action" :action="item"
                                             v-for="item in actionData">{{item.action}}
                            </a-select-option>
                        </a-select>
                    </div>
                </a-col>

                <!--value column-->
                <a-col :span="4" v-if="scanningActionSettingsItem.action == 'Check Prefix'">
                    <div class="ml4">
                        <label class="foldText">{{ $t('handheldConfiguration.value') }}</label>
                        <a-input v-model="scanningcheckPrefix"></a-input>
                    </div>

                </a-col>

                <!--type column-->
                <a-col :span="4" v-if="scanningActionSettingsItem.action == 'Check Length & Type'">
                    <div class="ml4">
                        <label class="foldText">{{ $t('handheldConfiguration.type') }}</label>
                        <a-select show-search
                                  optionFilterProp="label"
                                  v-model="scanningActionCode"
                                @change="typeChange">
                            <a-select-option :label="item"  :value="item" :key="item" v-for="item in checkLengthTypeData">{{item}}</a-select-option>
                        </a-select>
                    </div>

                </a-col>

                <!--target Column-->
                <a-col :span="7" v-if="scanningActionSettingsItem.action == 'Store Value' || scanningActionSettingsItem.action == 'Value Lookup'">
                    <div class="ml4">
                        <label class="foldText">{{ $t('handheldConfiguration.targetField') }}</label>
                        <a-select show-search
                                  v-model="scanningTargetField"
                                  @change="targetFieldChange"
                             >
                            <a-select-option :label="item" :value="item" v-for="item in targetFieldItems">{{item}}</a-select-option>
                        </a-select>
                    </div>

                </a-col>


                <!--length-->
                <a-col :span="2" v-if="scanningActionSettingsItem.action == 'Check Length & Type'">
                    <div class="ml4">
                        <label class="foldText" >{{ $t('handheldConfiguration.length') }}</label>
                        <a-input v-model="scanningcheckLengthData"></a-input>
                    </div>
                </a-col>

            </div>


        </div>
    </div>


</template>
<script>
    export default {
        props:['scanningActionSettingsItem', 'index','targetFieldItems' ],
        data() {
            return {
                actionData:[
                    {code:'Prefix',action:'Check Prefix'},
                    {code:'Data Type',action:'Check Length & Type'},
                    {code:'Field',action:'Store Value'},
                    {code:'Field',action:'Value Lookup'}
                ],
                scanningAction:this.scanningActionSettingsItem.action,
                checkLengthTypeData:[
                    'Alphanumeric'
                ],
                rowIndex: this.index + 1,
                scanningCheckLengthActionType:'',

                actionSelectedValue:{},
                scanningActionCodeTypeVale:'',
                scanningcheckPrefixData:'',
                checkLengthData:'',
                scanningTargetFieldData:'',
            }
        },
        watch: {
            scanningcheckPrefixData(val) {
                this.$emit('scanningcheckPrefixChange',this.index, 'Prefix', this.scanningcheckPrefixData)
            },
            checkLengthData(val){
                this.$emit('checkLengthDataChange',this.index, 'Length', val)
            }

        },
        computed:{
            scanningActionCode: {
                get: function () {
                    if(this.scanningActionSettingsItem.actionScanningType == null || this.scanningActionSettingsItem.actionScanningType.length == 0) {
                        return null;
                    }
                    return this.scanningActionSettingsItem.actionScanningType.find(item => item.type === 'Data Type').value;
                },
                set: function (newValue) {
                    this.scanningActionCodeTypeVale = newValue;
                }
            },
            scanningcheckPrefix:{
                get(){
                    if(this.scanningActionSettingsItem.actionScanningType == null || this.scanningActionSettingsItem.actionScanningType.length == 0) {
                        return null;
                    }
                    return this.scanningActionSettingsItem.actionScanningType.find(item => item.type === 'Prefix').value;
                },
                set(newValue){
                    this.scanningcheckPrefixData = newValue;
                }
            },
            scanningTargetField:{
                get(){
                    if(this.scanningActionSettingsItem.actionScanningType == null || this.scanningActionSettingsItem.actionScanningType.length == 0) {
                        return null;
                    }
                    return this.scanningActionSettingsItem.actionScanningType.find(item => item.type === 'Field').value;
                },
                set(newValue){
                    this.scanningTargetFieldData = newValue;
                }
            },
            scanningcheckLengthData:{
                get(){
                    if(this.scanningActionSettingsItem.actionScanningType == null || this.scanningActionSettingsItem.actionScanningType.length <= 1) {
                        return null;
                    }
                    return this.scanningActionSettingsItem.actionScanningType.find(item => item.type === 'Length').value;
                },
                set(newValue){
                    this.checkLengthData = newValue;
                }
            }

        },
        methods: {
            scanningSearchStepActionDelete() {
                this.$emit('scanningStepActionDelete',this.index);
            },
            actionChange(value, option) {
                this.actionSelectedValue = option.data.attrs.action;
                this.$emit('scanningActionChange',this.index,this.scanningAction)
            },
            typeChange() {
                this.$emit('scanningTypeChange',this.index,this.scanningActionCodeTypeVale, 'Data Type')
            },
            targetFieldChange(){
                this.$emit('scanningTargetFieldChange',this.index,'Field',this.scanningTargetFieldData);
            },

        }

    };
</script>